import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/App';
import '@/index.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element #root missing');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Service Worker nur im Produktions-Build – im Dev-Server würde er Hot Reload stören.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Nur für den Einlass: Shop, Verwaltung und die Seiten der Website brauchen keinen Offline-Betrieb.
    navigator.serviceWorker.register('/sw.js', { scope: '/einlass' }).catch((error: unknown) => console.warn('Service worker registration failed', error));
  });
}
